import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { PreloaderColor } from '@enums/shared.enum';
import { features } from '@consts/text.const';
import * as MenuActions from '@states/menu/menu.actions';
import { MenuKey } from '@enums/menu.enum';
import { Store } from '@ngrx/store';
import { SharedActions } from '@states/shared/shared.action-types';
import { TranslatePipe } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { ExistingUniformsComponent } from './existing-uniforms/existing-uniforms.component';
import { UnsavedUniformsComponent } from './unsaved-uniforms/unsaved-uniforms.component';
import { syncQueryParam } from '../../../../helpers/sync-query-param.helper';

type TabTypes = 'existing' | 'unsaved';

@Component({
  selector: 'app-uniform',
  templateUrl: './uniform.component.html',
  styleUrls: ['./uniform.component.scss'],
  imports: [TranslatePipe, NgIf, ExistingUniformsComponent, UnsavedUniformsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniformComponent implements OnInit, OnDestroy {
  public preloaderColor = PreloaderColor;

  protected readonly currentTab = syncQueryParam<TabTypes>('tab', { defaultValue: 'existing' });

  constructor(private store$: Store) {}

  public ngOnInit(): void {
    this.store$.dispatch(
      MenuActions.setActiveLevel2Menu({
        activeLevel2: MenuKey.uniform,
      }),
    );
    this.store$.dispatch(SharedActions.setIsLoading({ isLoading: false }));
  }

  public setActiveTab(tab: TabTypes): void {
    this.currentTab.set(tab);
  }

  public ngOnDestroy(): void {}
}
